import React from "react";
import "./AboutUs.css";
function AboutUs() {
  return (
    <div className="about-conatiner">
      <h1>A Journey in the Making :चार-धाम-यात्रा</h1>

      <p>
        चार-धाम-यात्रा 's Story is one of the Wanderlust and Wonder. It start
        with a simple dream to connect people with the holy places in india .
        We've on a mission to inspire and celebrate the global community of holy
        places. Our Journey is your Journey , and together ,we'll keep exploring
        ,one destination at a time.
      </p>
      <h1>Our Mission</h1>
      <p>
        At चार-धाम-यात्रा, our mission is to connect people with their spiritual
        and cultural heritage by providing a seamless and meaningful journey to
        the world's holiest places. We are committed to enabling travelers to
        embark on pilgrimages and spiritual explorations with ease, reverence,
        and deep cultural understanding. Join us in our mission to make
        spiritual and cultural travel more accessible, respectful, and
        enriching. Together, we can create transformative journeys to holy
        places that leave a lasting impact on the hearts and minds of travelers.
      </p>
      <h1>our vision</h1>
      <p>
        At चार-धाम-यात्रा, our vision is to become the foremost companion for
        spiritual seekers, cultural enthusiasts, and curious travelers on their
        journeys to India's sacred places. We aim to be the trusted gateway to
        the divine and the spiritual heritage of this incredible nation.We
        envision a future where travelers from all walks of life can immerse
        themselves in the diverse and rich cultural tapestry of India. Our app
        will be the bridge that deepens their understanding of India's spiritual
        and cultural wealth.
      </p>
    </div>
  );
}

export default AboutUs;
